import { render, staticRenderFns } from "./DetailModal.vue?vue&type=template&id=079c875e&scoped=true"
import script from "./DetailModal.vue?vue&type=script&lang=js"
export * from "./DetailModal.vue?vue&type=script&lang=js"
import style0 from "./DetailModal.vue?vue&type=style&index=0&id=079c875e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079c875e",
  null
  
)

export default component.exports